import { FC } from 'react';

import { RoomBookingFilterButton } from '../../RoomBookingFilters/RoomBookingFilterButton';
import { RoomBookingDateField } from '../../RoomBookingSettings/RoomBookingDateField';
import { RoomBookingTimeField } from '../../RoomBookingSettings/RoomBookingTimeField';
import { RoomOfficeSidesheetButton } from '../../RoomOffice/RoomOfficeSidesheetButton';
import { RoomSearch } from '../../RoomSearch/RoomSearch';

import classes from './MobilePageActions.module.scss';

export const MobilePageActions: FC = () => {
  return (
    <div className={classes.container}>
      <div className={classes.office}>
        <RoomOfficeSidesheetButton />
      </div>
      <div className={classes.date}>
        <RoomBookingDateField />
      </div>
      <div className={classes.time}>
        <RoomBookingTimeField />
      </div>
      <div className={classes.controls}>
        <div className={classes.search}>
          <RoomSearch />
        </div>
        <RoomBookingFilterButton />
      </div>
    </div>
  );
};
